import React from "react";
import { CheckCircle2, Monitor, Smartphone, Tablet } from "lucide-react";

export default function UnifiedPlatform() {
  return (
    <section id="platform" className="py-20 md:py-28">
      <div className="container-cv grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <span className="section-eyebrow">One unified platform</span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold text-primary leading-[1.08] tracking-tight">
            Simplify Entity Management and Compliance{" "}
            <span className="text-accent">in one unified platform.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed max-w-xl">
            Managing entities, compliance deadlines, and board activities manually leads
            to risk and inefficiencies. CoSec centralises everything into one platform,
            helping businesses stay compliant and in control.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-3 max-w-xl">
            {[
              "Multi-entity oversight",
              "Automated filings & reminders",
              "Secure audit trails",
              "Real-time compliance score",
              "AI-powered workflows",
              "Companies House integration",
            ].map((t, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm font-medium text-primary">
                <span className="lime-tick mt-0.5"><CheckCircle2 className="h-4 w-4" /></span>
                {t}
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-6">
          <div className="relative">
            <div className="absolute -inset-6 bg-gradient-to-br from-accent/15 via-transparent to-primary/10 rounded-3xl blur-2xl" />
            <div className="relative">
              <img
                src="/assets/cosec-multi-device.png"
                alt="CoSec running on desktop and mobile. Multi-device access system"
                className="w-full h-auto rounded-2xl"
                loading="lazy"
                data-testid="unified-platform-image"
              />
              {/* Device row */}
              <div className="mt-4 flex items-center justify-center gap-6 text-muted-foreground">
                <div className="flex items-center gap-1.5 text-xs"><Monitor className="h-4 w-4" /> Desktop</div>
                <div className="flex items-center gap-1.5 text-xs"><Tablet className="h-4 w-4" /> Tablet</div>
                <div className="flex items-center gap-1.5 text-xs"><Smartphone className="h-4 w-4" /> Mobile</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
